export default __webpack_public_path__ + "static/media/Pistol_3.de10aeda.png";